import styled from 'styled-components';

export const FilePicker = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const HiddenInput = styled.div`
  display: none;
`;
